module.exports = __webpack_public_path__ + "img/remitances.2ebcbc6b.png";